// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyDRjNCq-DzXzc22SBCuufC47UmSiwLhVhE",
    authDomain: "hackerlinxdev-a70df.firebaseapp.com",
    databaseURL: "https://hackerlinxdev-a70df.firebaseio.com",
    projectId: "hackerlinxdev-a70df",
    storageBucket: "hackerlinxdev-a70df.appspot.com",
    messagingSenderId: "83511232378",
    appId: "1:83511232378:web:32f52a4a9864e168"
  },
  firebaseConfigSecondary: {
    apiKey: "AIzaSyD1Bly-AfSrgrsckpn_hV2NiOg_45MnFuQ",
    authDomain: "blast-furnace-4e5c4.firebaseapp.com",
    databaseURL: "https://blast-furnace-4e5c4.firebaseio.com",
    projectId: "blast-furnace-4e5c4",
    storageBucket: "blast-furnace-4e5c4.appspot.com",
    messagingSenderId: "937821571231",
    appId: "1:937821571231:web:915299c7e24a36e6",
    measurementId: "G-XRL4Z6KXT7"
  },
  developmentEnv: "Development",
  googleAPIKey: "AIzaSyDsSo1aQWDo5qSnPlRDYkKHV04fU2swgCI",
  metadata: {
    name: 'Blast Furnace',
    url: "https://blastfurnace.com.au",
    image: 'https://firebasestorage.googleapis.com/v0/b/hackerlinx-460dd.appspot.com/o/logo-white-trans.png?alt=media&token=208fad17-4b2a-49c6-93eb-caa2f8f2c448',
    site: '@_BlastFurnace',
    video: 'https://www.youtube.com/watch?v=mQGJyxIDNnc'
  },
  domain: "https://dev.cyferlinx.com"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
